import { useCollaborationContext } from '@/modules/document/_helpers/CollaborationContext'
import { getCollaboratorDmsFrontendToken } from '@/modules/file/fileService'
import thumbnailService from '@/modules/file/thumbnailService'
import { setDmsToken } from '@/redux/ducks/tenant/settings'
import { dispatch, getAppState } from '@/redux/store'

let latestDmsTokenSelection = 0

export function useDmsCollaborationToken() {
  const { setCollaborationId } = useCollaborationContext()

  return async function reset(collaborationId, callback) {
    const selection = ++latestDmsTokenSelection
    const dmsTokenSessionEpoch = getAppState().tenant.settings.dmsTokenSessionEpoch ?? 0
    const requestIsCurrent = () => selection === latestDmsTokenSelection
      && (getAppState().tenant.settings.dmsTokenSessionEpoch ?? 0) === dmsTokenSessionEpoch
    let response
    try {
      response = await getCollaboratorDmsFrontendToken(collaborationId ?? 'internal')
    } catch (error) {
      if (!requestIsCurrent()) return
      throw error
    }
    if (!requestIsCurrent()) return

    const { data: { data: dmsToken } } = response
    setCollaborationId(collaborationId)
    dispatch(setDmsToken(dmsToken, collaborationId ?? 'internal', dmsTokenSessionEpoch))
    thumbnailService.clear()
    callback?.()
  }
}
